export const SalsaBadge = (props = {}) => {
    const className = 'text-xs px-4 py-1.5 rounded-full bg-gray-100 whitespace-nowrap max-w-full w-min overflow-hidden text-ellipsis inline-block'
    return (
        <span className={className}>{props.label}</span>
    )
}

export default SalsaBadge